import users from '@/api/apiUsersManagement/services/users'
import config from '@/utils/config'
import session from '@/auth/session'

export const getMulticompany = ({ commit, dispatch }) => {
  let body = {
    username: session.getSecValue('username'),
    promotercode: config.promoterCode
  }
  return new Promise((resolve, reject) => {
    users.getMulticompany(body).then((res) => {
      if (!Array.isArray(res.data)) reject(new Error(`${res.data} must be an array`))
      Promise.all([
        new Promise(resolve => resolve(true)),
        res.data.map(multicompany => dispatch('addItem', {
          username: multicompany.username,
          tradename: multicompany.nif + ' - ' + multicompany.tradename
        }))
      ]).then(() => {
        resolve()
      }, (err) => {
        reject(err)
      })
    }).catch((e) => {
      reject(new Error(e))
    })
  })
}

/**
 * Add user to multicompany
 * @param {Object} payload - Add user Object to multicompany list.
 */
export const addItem = ({ commit }, payload) => {
  return new Promise((resolve) => {
    commit('ADD', payload)
    resolve()
  })
}

export const removeItem = ({ commit }, key) => {
  return new Promise((resolve) => {
    commit('DELETE', key)
    resolve()
  })
}

export const empty = ({ commit, dispatch, state }) => {
  return new Promise((resolve) => {
    if (!state.list.length) resolve()
    Promise.all([
      state.list.map((key) => {
        return dispatch('removeItem', key)
      })
    ]).then(() => {
      resolve()
    })
  })
}
